import { types } from 'mobx-state-tree';
import { castEventToValue } from 'js/services/FormTools';
import Address from 'js/stores/types/Address';
import AppUser from 'js/stores/AppUser';

export default types
  .model('User', {
    id: 0,
    name: types.optional(types.maybeNull(types.string), AppUser.name),
    login: types.optional(types.maybeNull(types.string), AppUser.login),
    first_name: types.optional(types.maybeNull(types.string), AppUser.first_name),
    last_name: types.optional(types.maybeNull(types.string), AppUser.first_name),
    email: types.optional(types.maybeNull(types.string), AppUser.email),
    phone_number: types.optional(types.maybeNull(types.string), () => AppUser.phone_number || ''),
    phone_number_formatted: types.optional(types.maybeNull(types.string), AppUser.phone_number_formatted),
    address: types.optional(Address, {}),
    notification_method: types.optional(types.maybeNull(types.string), AppUser.notification_method),
  })
  .actions(self => ({
    setFirstName(first_name) {
      self.first_name = castEventToValue(first_name);
      return self;
    },
    setLastName(last_name) {
      self.last_name = castEventToValue(last_name);
      return self;
    },
    setName(name) {
      self.name = castEventToValue(name);
      return self;
    },
    setLogin(checkoutName) {
      self.login = castEventToValue(checkoutName);
      return self;
    },
    setPhoneNumber(phone_number) {
      self.phone_number = castEventToValue(phone_number) || '';
      localStorage.setItem('phone_number', self.phone_number);
      return self;
    },
    setPhoneNumberFormatted(phone_number_formatted) {
      self.phone_number_formatted = castEventToValue(phone_number_formatted) || '';
      localStorage.setItem('phone_number_formatted', self.phone_number_formatted);
      return self;
    },
    setNotificationMethod(notification_method) {
      self.notification_method = castEventToValue(notification_method);
      return self;
    },
  }));
